import { render, staticRenderFns } from "./ManagePropertiesStatus.vue?vue&type=template&id=66a424ef"
import script from "./ManagePropertiesStatus.vue?vue&type=script&lang=js"
export * from "./ManagePropertiesStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports